<h2
  mat-dialog-title
  style="color: white"
  class="title-text theme-background-color mb-2">
  Attach Invoice
</h2>

<section class="content-header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
          <div class="card-body mb-2 custom-body">
            <div class="row">
              <div class="container" *ngIf="showAlert">
                <div
                  class="alert alert-warning alert-dismissible fade show"
                  role="alert">
                  <strong>Warning!</strong
                  >{{
                    ' All amounts displayed here are in the currency of the advance payment ' +
                      paymentDetails.currency?.code +
                      ', and the payment will also default to the same currency.'
                  }}

                  <button
                    type="button"
                    class="close"
                    (click)="closeAlert()"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="invoiceId"
                    >Invoice <span class="text-danger">*</span>
                    <span class="optional-text"> </span
                  ></label>
                  <ng-select
                    (clear)="clearSearchInvoice()"
                    (input)="onInputInvoice($event)"
                    (blur)="onFocus(false, 'invoiceId')"
                    (focus)="onFocus(true, 'invoiceId')"
                    id="invoiceId"
                    name="invoiceId"
                    [searchFn]="customSearchFnCurrency"
                    [ngClass]="{
                      'is-invalid':
                        paymentForm.get('invoiceId')?.hasError('required') &&
                        paymentForm.get('invoiceId')?.touched
                    }"
                    formControlName="invoiceId"
                    [items]="invoiceOptions"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [bindLabel]="'name'"
                    [searchable]="true"
                    placeholder="Select Invoice">
                    <ng-template ng-label-tmp let-item="item">
                      <div>
                        <ng-container *ngIf="item.invoiceNumber">
                          <span class="rectangle-tag bg-success mr-2">{{
                            item.invoiceNumber
                          }}</span>
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index">
                      <div>
                        <ng-container *ngIf="item?.invoiceNumber">
                          <span class="rectangle-tag bg-success mr-2">{{
                            item.invoiceNumber
                          }}</span>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ng-select>
                  <span class="error invalid-feedback"
                    >Please select an invoice</span
                  >
                </div>
              </div>

              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="vat">
                    Type <span class="text-danger">*</span></label
                  >

                  <ng-select
                    id="paymentType"
                    name="paymentType"
                    [closeOnSelect]="true"
                    [ngClass]="{
                      'is-invalid':
                        paymentForm.get('paymentType')?.hasError('required') &&
                        paymentForm.get('paymentType')?.touched
                    }"
                    formControlName="paymentType"
                    [items]="
                      paymentStatus === 'PARTIAL'
                        ? partialPaymentOptions
                        : paymentTypeOptions
                    "
                    [multiple]="false"
                    [bindLabel]="'name'"
                    [clearable]="false"
                    [searchable]="true"
                    placeholder="Select attachment type">
                  </ng-select>
                  <span class="error invalid-feedback"
                    >Please select a payment type
                  </span>
                </div>
              </div>

              <ng-container
                *ngIf="
                  paymentForm.get('paymentType')?.value?.value === 'PARTIAL'
                ">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label for="currencyId"
                      >Payment Currency <span class="text-danger">*</span>
                      <span class="optional-text"> </span
                    ></label>
                    <ng-select
                      (clear)="clearSearchCurrency()"
                      (input)="onInputCurrency($event)"
                      (blur)="onFocus(false, 'currencyId')"
                      (focus)="onFocus(true, 'currencyId')"
                      id="currencyId"
                      name="currencyId"
                      [searchFn]="customSearchFnCurrency"
                      [ngClass]="{
                        'is-invalid':
                          paymentForm.get('currencyId')?.hasError('required') &&
                          paymentForm.get('currencyId')?.touched
                      }"
                      formControlName="currencyId"
                      [items]="currencyOptions"
                      [multiple]="false"
                      [closeOnSelect]="true"
                      [bindLabel]="'name'"
                      [searchable]="true"
                      placeholder="Select an invoice ">
                      <ng-template ng-label-tmp let-item="item">
                        <div>
                          <span class="rectangle-tag bg-success mr-2"
                            >{{ item.code }}
                          </span>
                          <span class="rectangle-tag bg-info mr-2">{{
                            item.name
                          }}</span>
                        </div>
                      </ng-template>
                      <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index">
                        <div>
                          <span class="rectangle-tag bg-success mr-2"
                            >{{ item?.code }}
                          </span>
                          <span class="rectangle-tag bg-info">{{
                            item?.name
                          }}</span>
                        </div>
                      </ng-template>
                    </ng-select>
                    <span class="error invalid-feedback"
                      >Please select a currency</span
                    >
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label for="amountPaid"
                      >Pay Amount <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      formControlName="amountPaid"
                      [ngClass]="{
                        'is-invalid':
                          (paymentForm
                            .get('amountPaid')
                            ?.hasError('required') &&
                            paymentForm.get('amountPaid')?.touched) ||
                          (paymentForm.get('amountPaid')?.hasError('pattern') &&
                            paymentForm.get('amountPaid')?.touched) ||
                          paymentForm.get('amountPaid')?.hasError('max')
                      }"
                      placeholder="Enter amount paid" />
                    <span class="error invalid-feedback">
                      <ng-container
                        *ngIf="
                          paymentForm.get('amountPaid')?.hasError('required')
                        ">
                        Please enter the amount paid.
                      </ng-container>
                      <ng-container
                        *ngIf="
                          paymentForm.get('amountPaid')?.hasError('pattern')
                        ">
                        Please enter a valid amount.
                      </ng-container>
                      <ng-container
                        *ngIf="paymentForm.get('amountPaid')?.hasError('max')">
                        Amount should not exceed the invoice or payment balance.
                      </ng-container>
                    </span>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label for="invoiceBalance">Invoice Balance </label>
                    <input
                      placeholder="Select an invoice "
                      type="text"
                      class="form-control"
                      formControlName="invoiceBalance" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label for="balanceAmount">Payment Balance </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="balanceAmount" />
                  </div>
                </div>
              </ng-container>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="remark">Remark</label>
                  <textarea
                    id="remark"
                    class="form-control"
                    formControlName="remarks"
                    rows="3"
                    placeholder="Enter remarks"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer-display mr-4 mt-2">
            <button
              type="button"
              class="btn btn-secondary float-right"
              (click)="onCancel()">
              Cancel
            </button>

            <button
              type="submit"
              [disabled]="paymentForm.invalid"
              class="btn btn-primary float-right custom-button">
              <ng-container *ngIf="loader; else submitText">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"></span>
              </ng-container>
            </button>
            <ng-template #submitText>Submit </ng-template>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
